// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paylixecommerce-radio-container {
  display: block;
  position: relative;
  padding-left: 28px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.paylixecommerce-radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.paylixecommerce-radio-container input:checked ~ .paylixecommerce-radio-checkmark {
  background-color: var(--purple6);
}
.paylixecommerce-radio-container input:checked ~ .paylixecommerce-radio-checkmark:after {
  top: 6px;
  left: 6px;
  width: 6px;
  height: 6px;
}
.paylixecommerce-radio-container:hover input ~ .paylixecommerce-radio-checkmark {
  background-color: var(--purple5);
}
.paylixecommerce-radio-checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;
  width: 18px;
  background-color: var(--black2);
  border-radius: 50%;
}
.paylixecommerce-radio-checkmark:after {
  content: "";
  position: absolute;
  display: block;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: white;
}`, "",{"version":3,"sources":["webpack://./client/components/fields/radio/styles.scss"],"names":[],"mappings":"AACE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AAAN;AAEM;EACE,gCAAA;AAAR;AAGM;EACE,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AADR;AAKI;EACE,gCAAA;AAHN;AAME;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;AAJJ;AAKI;EACE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAHN","sourcesContent":[".paylixecommerce-radio {\n  &-container {\n    display: block;\n    position: relative;\n    padding-left: 28px;\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    input {\n      position: absolute;\n      opacity: 0;\n      cursor: pointer;\n      height: 0;\n      width: 0;\n\n      &:checked ~ .paylixecommerce-radio-checkmark {\n        background-color: var(--purple6);\n      }\n\n      &:checked ~ .paylixecommerce-radio-checkmark:after {\n        top: 6px;\n        left: 6px;\n        width: 6px;\n        height: 6px;\n      }\n    }\n\n    &:hover input ~ .paylixecommerce-radio-checkmark {\n      background-color: var(--purple5);\n    }\n  }\n  &-checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 18px;\n    width: 18px;\n    background-color: var(--black2);\n    border-radius: 50%;\n    &:after {\n      content: \"\";\n      position: absolute;\n      display: block;\n      top: 2px;\n      left: 2px;\n      width: 14px;\n      height: 14px;\n      border-radius: 50%;\n      background: white;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
